export { queries } from './queries/pricingEditor.queries'
